<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <start-packet-header></start-packet-header>
        <start-packet-table></start-packet-table>
        <start-packet-footer></start-packet-footer>
        <check-fto></check-fto>
        <start-packet-list></start-packet-list>
        <start-packet-update></start-packet-update>
    </b-col>
</template>

<script>
    import CheckFto from './calculator/CheckFTO.vue';
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue';
    import StartPacketHeader from './start-packet/StartPacketHeader.vue';
    import StartPacketTable from './start-packet/StartPacketTable.vue';
    import StartPacketFooter from './start-packet/StartPacketFooter.vue';
    import StartPacketList from './start-packet/StartPacketList';
    import StartPacketUpdate from './start-packet/StartPacketUpdate.vue';

    export default {
        components: {
            CheckFto,
            FuturocoinsFromMining,
            StartPacketHeader,
            StartPacketTable,
            StartPacketFooter,
            StartPacketList,
            StartPacketUpdate
        }
    }
</script>

<style lang="scss" scoped>
    .space{
        margin-bottom: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/StartPacketContent.vue